import { useState } from "react";

export default function useGetCurrentLocation({ onSuccess } = {}) {
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchLocation = () => {
		if (!navigator.geolocation) {
			setError("unavailable");
			requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
			return;
		}

		setIsLoading(true);
		setError(null);

		navigator.geolocation.getCurrentPosition(
			(position) => {
				if (onSuccess) {
					onSuccess({
						latitude: position.coords.latitude,
						longitude: position.coords.longitude
					});
				}
				setIsLoading(false);
				requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
			},
			() => {
				setError("denied");
				setIsLoading(false);
				requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
			},
			{ timeout: 10000 }
		);
	};

	return { fetchLocation, isLoading, error };
}
